<template>
    <div class="modal fade md-show" tabindex="-1" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button class="close" type="button" data-dismiss="modal" aria-hidden="true"><span class="s7-close"></span></button>
          </div>
          <div class="modal-body">
            <div id="qrcode-servicecall-printable-area">
              <div id="qrcode-servicecall-wrapper" class="card">
                <div id="qrcode-servicecall"></div>
              </div>
              <div class="details">
                <div style="font-size: 25px;letter-spacing: 2px;"><b>Scan for Service</b></div>
                <div>{{ user.name }}</div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button v-on:click="print" class="btn btn-link btn-space btn-link-primary full" type="button">{{ t("Print") }}</button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import 'print-js/dist/print.css';
import 'print-js/dist/print.js';
import logo from '../assets/img/maprinter-qrcode.png';
import { mapState } from "vuex";

const QRCode = require('easyqrcodejs');
export default {
  computed: {
    ...mapState({
      user: state => state.user.data
    })
  },
  methods: {
    open: (link) => {
      document.getElementById("qrcode-servicecall").innerHTML = '';
      const text = link;
      const color = '#000000';
      new QRCode(document.getElementById("qrcode-servicecall"), {
          text: text,
          width: 225,
          height: 225,
          colorDark : "#000000",
          colorLight : "#ffffff",
          correctLevel : QRCode.CorrectLevel.Q,
          dotScale: 0.6,
          logo,
          logoWidth:100,
          logoHeight:100,
          logoBackgroundTransparent:true,
          PI: color,
          AI: color,
          timing: '#ffffff',
      });
    },
    print: () => {
      printJS({ printable: 'qrcode-servicecall-printable-area', type: 'html', targetStyles: '*', style: 'body { padding: 0; margin: 0 } #qrcode-servicecall-wrapper { margin: 0 !important } #qrcode-servicecall-printable-area { margin: 0 !important; width: 245px; }' });
    }
  },
};
</script>

<style lang="scss">
#app {
    #qrcode-servicecall-modal {
      #qrcode-servicecall-printable-area {
        max-width: 245px;
        margin: 0 auto;
      }
      #qrcode-servicecall-wrapper {
        margin: 0 auto;
        color: black;
        font-family: monospace;
        width: 100%;
        max-width: 245px;
        .top-qrcode {
          font-size: 1.8em;
          margin-bottom: 15px;
          letter-spacing: 1px;
          line-height: 30px;
        }
        #qrcode {
          width: 100%;
          canvas, img {
            width: 100%;
          }
        }
      }
      .details {
        font-size: 20px;
        padding: 5px;
        width: 245px;
        margin: 0 auto;
      }
      .modal-content {
        min-width: 320px;
        width: 320px;
        margin: 0 auto;
        margin-top: 14vh;
        .modal-body {
          text-align: center;
          padding-top: unset;
          padding: 0;
        }
        .modal-footer {
          justify-content: unset;
          .btn-link {
              margin: 0 auto;
              border: 1px solid;
              font-size: 14px;
              font-weight: bold;
              text-transform: capitalize;
          }
        }
      }
    }
    .hide {
      display: none;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/QRCode-ServiceCall.vue